import script from "./resultSuggestionsLower.vue?vue&type=script&setup=true&lang=ts"
export * from "./resultSuggestionsLower.vue?vue&type=script&setup=true&lang=ts"

import "./resultSuggestionsLower.vue?vue&type=style&index=0&id=9139a77a&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9139a77a"]])

export default __exports__